export const MICROSOFT_TECH_TAGS = [
  'Azure',
  'Azure AI',
  'Azure Data',
  'Azure DevOps',
  'Azure Networking',
  'Azure Security',
  'Azure Stack',
  'Business Central',
  'Copilot',
  'Dynamics 365',
  'GitHub',
  'GitHub Actions',
  'GitHub Copilot',
  'Microsoft 365',
  'Microsoft Defender',
  'Microsoft Fabric',
  'Microsoft Sentinel',
  'Microsoft Teams',
  'Microsoft Viva',
  'Power Apps',
  'Power Automate',
  'Power BI',
  'Power Platform',
  'SQL Server',
  'Surface & Windows',
];

export const COMMON_CERT_CODES = [
  'MCT',
  'AZ-900', 'AZ-104', 'AZ-204', 'AZ-305', 'AZ-400', 'AZ-500', 'AZ-700', 'AZ-800',
  'AI-900', 'AI-102',
  'DP-900', 'DP-203', 'DP-300', 'DP-420',
  'SC-900', 'SC-200', 'SC-300', 'SC-400',
  'MS-900', 'MS-102', 'MS-700',
  'PL-900', 'PL-400', 'PL-600',
  'MB-910', 'MB-210', 'MB-310', 'MB-920',
  'GitHub Foundations',
];
